import { UITableViewCell, UILabel, UIImageView } from "uikit";
import { NSLocalizeString } from "foundation";
import { MIOStringWithFormat } from "mio-core";
import { DLDB } from "dldb";

/**
 * One venue event (VenueEvent) in the events step. Expects the JSON returned by /events:
 * ID, Name, Day, BeginDateTime, EndDateTime, MinPax, MaxPax, RemainingPax, Price, PresetID, Type
 */
export class BookingEventCell extends UITableViewCell
{
    private imageView  : UIImageView;
    private nameLabel  : UILabel;
    private dateLabel  : UILabel;
    private timeLabel  : UILabel;
    private infoLabel  : UILabel;
    private priceLabel : UILabel;

    awakeFromNib ( ) { }

    private _event: any = null;
    get event ( ) { return this._event; }
    set event ( event: any ) {
        this._event = event;

        this.nameLabel.text = event[ "Name" ];
        if ( this.imageView && event[ "ImageURL" ] ) this.imageView.imageURL = event[ "ImageURL" ];

        if ( this.dateLabel ) {
            const date = BookingEventCell.dateText( event );
            const time = BookingEventCell.timeText( event );
            // Layouts without the time line keep date and time together in the date label
            this.dateLabel.text = this.timeLabel || time == "" ? date : date + " " + time;
        }
        if ( this.timeLabel ) this.timeLabel.text = BookingEventCell.timeText( event );
        if ( this.infoLabel ) this.infoLabel.text = BookingEventCell.infoText( event );

        if ( this.priceLabel ) {
            const price = event[ "Price" ] ?? 0;
            this.priceLabel.text = price > 0 ? DLDB.shared.currencyFormatter().stringFromNumber( price ) : "";
        }
    }

    // Long localized date ("28 de agosto de 2026") built from the server's yyyy-mm-dd, no time
    // zone math: the calendar day goes into a local Date only to feed the formatter.
    static dateText ( event: any ) : string {
        const day: string = ( event[ "BeginDateTime" ] ?? "" ).substring( 0, 10 ) || event[ "Day" ] || "";
        const [ y, m, d ] = day.split( "-" ).map( Number );
        if ( !y || !m || !d ) return "";

        try {
            return new Date( y, m - 1, d ).toLocaleDateString( DLDB.shared.pageLanguage, { dateStyle: "long" } );
        }
        catch {
            return day.split( "-" ).reverse().join( "/" );
        }
    }

    // "HH:MM - HH:MM" from the server strings (yyyy-mm-dd HH:MM)
    static timeText ( event: any ) : string {
        const from = ( event[ "BeginDateTime" ] ?? "" ).substring( 11, 16 );
        const to   = ( event[ "EndDateTime" ] ?? "" ).substring( 11, 16 );
        if ( from == "" ) return "";
        return to != "" ? from + " - " + to : from;
    }

    static infoText ( event: any ) : string {
        const parts: string[] = [];

        if ( event[ "Type" ] ) parts.push( event[ "Type" ] );

        const remaining = event[ "RemainingPax" ];
        if ( remaining != null ) {
            parts.push( MIOStringWithFormat( NSLocalizeString( "EVENT PLACES LEFT", "%i places left" ), remaining ) );
        }

        const min = event[ "MinPax" ] ?? 0, max = event[ "MaxPax" ] ?? 0;
        if ( min > 1 ) parts.push( MIOStringWithFormat( NSLocalizeString( "EVENT MIN PAX", "min. %i people" ), min ) );
        if ( max > 0 && remaining == null ) parts.push( MIOStringWithFormat( NSLocalizeString( "EVENT MAX PAX", "max. %i people" ), max ) );

        return parts.join( " · " );
    }
}
